import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { auth } from '../firebase';
import '../styles/Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  
  const { login, currentUser, userType, loading: authLoading } = useAuth();

  // Redirect if user is already logged in
  useEffect(() => {
    if (currentUser) {
      const from = location.state?.from?.pathname || (userType === 'clinician' ? '/clinician' : '/patient');
      navigate(from, { replace: true });
    }
  }, [currentUser, userType, navigate, location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // Basic validation
    if (!email || !password) {
      setError('Please enter both email and password');
      return;
    }
    
    try {
      setIsSubmitting(true);
      const result = await login(email, password);
      
      if (!result.success) {
        setError(result.error || 'Failed to log in. Please check your credentials.');
      }
      // Navigation will be handled by the useEffect above
    } catch (error) {
      console.error('Login error:', error);
      setError('An unexpected error occurred. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
        <img src={process.env.PUBLIC_URL + '/logo.png'} alt="Logo" className="header-logo" />

          {/* <h1>Llama</h1> */}
          <p>Secure access for healthcare professionals and patients</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              className="form-input"
              disabled={isSubmitting}
            />
          </div>
          
          <div className="form-group">
            <div className="password-label-container">
              <label htmlFor="password">Password</label>
            </div>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              className="form-input"
              disabled={isSubmitting}
            />
                          <a href="/forgot-password" className="forgot-password">Forgot Password?</a>

          </div>
          
          {error && <div className="error-message">{error}</div>}
          
          <button
            type="submit"
            className="login-button"
            disabled={isSubmitting || authLoading}
          >
            {isSubmitting ? (
              <>
                <span className="spinner"></span>
                Signing in...
              </>
            ) : (
              'Sign In'
            )}
          </button>
        </form>
        
        <div className="signup-link">
          <p>Don't have an account? <Link to="/register" className="register-link">Register as a patient</Link></p>
          <p className="small-text">For healthcare providers, please contact your administrator for access.</p>
        </div>
        
        {/* Debug info - remove in production */}
        <div style={{ marginTop: '20px', fontSize: '12px', color: '#666', textAlign: 'center' }}>
          <p>Debug Info:</p>
          <p>User Type: {userType || 'Not logged in'}</p>
          <p>Auth Loading: {authLoading ? 'Yes' : 'No'}</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
